import { combineReducers } from 'redux';
import {
  SET_BID_STAGING,
  SET_PAGE,
  SET_FILTER,
  CLEAR_FILTER,
  CLEAR_FILTERS,
  MARK_STAGING_LOADING,
  SET_VALIDATION,
  UPDATE_STAGING_EQUIP,
  SET_STAGING_FIELDS,
  SET_SELECTED_POINTS,
  REMOVE_SELECTED_POINTS,
  CLEAR_SELECTED_POINTS,
  REMOVE_SELECTED_EQUIPMENT,
  CLEAR_SELECTED_EQUIPMENT,
  SET_SELECTED_EQUIPMENT,
} from '../actions/actiontypes';

const page = (state = 0, action) => {
  if (action.type === SET_FILTER || action.type === CLEAR_FILTER || action.type === CLEAR_FILTERS) {
    return 0;
  }
  if (action.type === SET_PAGE) {
    return action.newPage;
  }

  return state;
};

const filters = (state = [], action) => {
  if (action.type === CLEAR_FILTERS) {
    return [];
  }

  // Guard statement for non-filters
  if (!action.filter) return state;

  const newState = state.filter((f) => f.key() !== action.filter.key());

  if (action.type === SET_FILTER) {
    return [...newState, action.filter];
  }
  if (action.type === CLEAR_FILTER) {
    return newState;
  }
  return state;
};

const selectedPoints = (state = [], action) => {
  if (action.type === CLEAR_SELECTED_POINTS) return [];
  if (action.type === REMOVE_SELECTED_POINTS)
    // state - action.points
    return state.filter((e) => !action.points.includes(e));
  if (action.type === SET_SELECTED_POINTS) return action.points;
  if (action.type === SET_FILTER || action.type === CLEAR_FILTER || action.type === CLEAR_FILTERS)
    return [];
  return state;
};

const selectedEquipment = (state = [], action) => {
  if (action.type === CLEAR_SELECTED_EQUIPMENT) return [];
  if (action.type === REMOVE_SELECTED_EQUIPMENT)
    // state - action.equipIds
    return state.filter((e) => !action.equipIds.includes(e));
  if (action.type === SET_SELECTED_EQUIPMENT) return action.equipment;
  if (action.type === SET_FILTER || action.type === CLEAR_FILTER || action.type === CLEAR_FILTERS)
    return [];
  return state;
};

const loaded = (state = {}, action) => {
  if (action.type === SET_BID_STAGING) {
    return { ...state, [action.buildingId]: true };
  }
  if (action.type === MARK_STAGING_LOADING) {
    return { ...state, [action.buildingId]: false };
  }
  return state;
};

const equipmentByBuilding = (state = {}, action) => {
  if (action.type === SET_BID_STAGING) {
    return { ...state, [action.buildingId]: action.equipment };
  }
  if (action.type === UPDATE_STAGING_EQUIP) {
    const newState = { ...state };
    if (!newState[action.buildingId]) {
      newState[action.buildingId] = action.equipment;
    } else {
      const updates = action.equipment.reduce((o, e) => {
        // eslint-disable-next-line no-param-reassign
        o[e.equip_id] = e;
        return o;
      }, {});
      newState[action.buildingId].forEach((e, i) => {
        const update = updates[e.equip_id];
        if (update != null) {
          newState[action.buildingId][i] = update;
        }
      });
    }
    return newState;
  }
  return state;
};

const fieldsByBuilding = (state = {}, action) => {
  if (action.type === SET_STAGING_FIELDS) {
    return { ...state, [action.buildingId]: action.data };
  }
  return state;
};

const pointsByEquipId = (state = {}, action) => {
  if (action.type === SET_BID_STAGING) {
    return { ...state, [action.buildingId]: action.points };
  }
  if (action.type === UPDATE_STAGING_EQUIP) {
    return {
      ...state,
      [action.buildingId]: {
        ...state[action.buildingId],
        ...action.points,
      },
    };
  }
  return state;
};

// validation reducers

const points = (state = {}, action) => {
  if (action.type === SET_VALIDATION) {
    return { ...state, [action.buildingId]: action.points };
  }
  if (action.type === SET_BID_STAGING && !(action.buildingId in state)) {
    return { ...state, [action.buildingId]: {} };
  }
  return state;
};

const equipment = (state = {}, action) => {
  if (action.type === SET_VALIDATION) {
    return { ...state, [action.buildingId]: action.equipment };
  }
  if (action.type === SET_BID_STAGING && !(action.buildingId in state)) {
    return { ...state, [action.buildingId]: {} };
  }
  return state;
};

const buildingErrors = (state = {}, action) => {
  if (action.type === SET_VALIDATION) {
    return { ...state, [action.buildingId]: action.buildingError };
  }
  if (action.type === SET_BID_STAGING && !(action.buildingId in state)) {
    return { ...state, [action.buildingId]: {} };
  }
  return state;
};

export default combineReducers({
  loaded,
  page,
  filters,
  selectedPoints,
  selectedEquipment,
  equipmentByBuilding,
  pointsByEquipId,
  validation: combineReducers({ points, equipment, buildingErrors }),
  fieldsByBuilding,
});
